import { render, staticRenderFns } from "./indicados.vue?vue&type=template&id=885b4036"
import script from "./indicados.vue?vue&type=script&lang=js"
export * from "./indicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports